export const PF = 'record-modal-ui';
